'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/TextAa.es.js";
const o = a.forwardRef((t, a$1) => /* @__PURE__ */ a.createElement(p, { ref: a$1, ...t, weights: e }));
o.displayName = "TextAaIcon";
const n = o;
export {
  n as TextAa,
  o as TextAaIcon
};
